import React from "react";
import { FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { useLocation } from "react-router-dom";

export const CustomDropdown = ({
  name = "",
  label,
  options,
  value,
  onChange,
  isDisabled,
  width = "100px",
  padding,
  height,
  isError = false,
  error = "",
  isRequired = false,
  customStyle = {}
}) => {
  const location = useLocation()
  return (
    <React.Fragment>
      {
        label ? <InputLabel
          sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "5px" }}
        >
          {label} {isRequired ? <span style={{ color: "red" }}>*</span> : null}
        </InputLabel>
          : null
      }

      <Select
        sx={{ width, backgroundColor: "white", fontSize: "14px", padding, height: height ? height : location?.pathname?.startsWith("/create/triggers") ? "25px" : height }}
        value={value}
        placeholder={label}
        name={name}
        size="small"
        onChange={onChange}
        disabled={isDisabled}
      >
        {options.map((option) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          );
        })}
      </Select>
      {isError ? <FormHelperText>{error}</FormHelperText> : null}
    </React.Fragment>
  );
};
